import { render, staticRenderFns } from "./extensionDoc.vue?vue&type=template&id=759250f8&scoped=true&"
import script from "./extensionDoc.vue?vue&type=script&lang=js&"
export * from "./extensionDoc.vue?vue&type=script&lang=js&"
import style0 from "./extensionDoc.vue?vue&type=style&index=0&id=759250f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "759250f8",
  null
  
)

export default component.exports